export default {
  items: {
    data: []
  },
  totals: {
    total_compensated: '0,00',
    total_due: '0,00',
    total_overdue: '0,00',
    total_general: '0,00'
  }
}
